import { Button } from '@/components/ui/button';
import {
    DialogActionTrigger,
    DialogBody,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogRoot,
    DialogTitle,
} from '@/components/ui/dialog';
import { api } from '@/lib/api';
import { Flex, Text } from '@chakra-ui/react';
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const ONE_MINUTE_IN_MILLISECONDS = 60000;
const FIVE_SECONDS_IN_MILLISECONDS = 5000;

export function SessionWarningModal() {
    const { t } = useTranslation();
    const location = useLocation();
    const [showWarning, setShowWarning] = useState(false);
    const [isContinue, setIsContinue] = useState(false);
    const [isLogout, setIsLogout] = useState(false);

    useEffect(() => {
        const interval = setInterval(async () => {
            const sessionExpiryTime = Cookies.get('musa-session-expiry');
            // if sessionExpiryTime is undefined, set remaining time to zero
            const remainingTime = parseInt(sessionExpiryTime ?? '0') - Date.now();
            // less than 1 minute but not expired yet
            if (remainingTime < ONE_MINUTE_IN_MILLISECONDS && remainingTime > 0 && !showWarning) {
                setShowWarning(true);
            } else if (remainingTime <= 0) {
                await api.authentication.logout();
                const path = location.pathname;
                window.location.href = `/login?expired=true&from=${path}`;
            }
            // interval every 5 seconds to check session status
        }, FIVE_SECONDS_IN_MILLISECONDS);

        return () => {
            clearInterval(interval);
        };
    }, [location.pathname, showWarning]);

    return (
        <DialogRoot lazyMount size="md" open={showWarning} closeOnInteractOutside={false}>
            <DialogContent colorPalette="purple">
                <DialogHeader>
                    <DialogTitle>Session Warning</DialogTitle>
                </DialogHeader>
                <DialogBody>
                    <Flex>
                        <Text>{t('SESSION.WARNING')}</Text>
                    </Flex>
                </DialogBody>
                <DialogFooter>
                    <DialogActionTrigger asChild>
                        <Button
                            variant="outline"
                            loading={isLogout}
                            disabled={isContinue}
                            onClick={async () => {
                                setIsLogout(true);
                                await api.authentication.logout();
                                window.location.href = `/login`;
                            }}>
                            Logoff
                        </Button>
                    </DialogActionTrigger>
                    <Button
                        loading={isContinue}
                        disabled={isLogout}
                        onClick={async () => {
                            try {
                                setIsContinue(true);
                                await api.authentication.authenticated();
                                setShowWarning(false);
                                setIsContinue(false);
                            } catch {
                                // if user cannot be authenticated for any reason when trying to continue session, log user out
                                await api.authentication.logout();
                                const path = location.pathname;
                                window.location.href = `/login?expired=true&from=${path}`;
                            }
                        }}>
                        Continue
                    </Button>
                </DialogFooter>
            </DialogContent>
        </DialogRoot>
    );
}

export default SessionWarningModal;
